<template>
    <modal name="item-select-modal" class="item-modal dgm-modal"
           :width="'80%'"
           :height="'80%'"
           @before-close="handlerBeforeClose"
           @before-open="handlerBeforeOpen"
           @opened="handlerOpened"
    >
        <div class="lookbook_item_wrap">
            <div class="li_title">상품등록</div>
            <button class="close_btn" @click="modalClose"></button>
            <elastic-list-component :elasticType="'modalSelect'" :defaultFilter="defaultFilter"></elastic-list-component>
            <div class="mt20 text-center">
                <el-button type="primary" @click="selectData">등록</el-button>
            </div>
        </div>
    </modal>

</template>

<script>
import elasticList from '@/mixins/elastic/elasticList.js'
import ElasticListComponent from "@/components/elastic/ElasticListComponent";
import util from "@/mixins/util";
import EventBus from "@/mixins/event-bus";
import alertMixins from "@/mixins/alertMixins"
export default {
    name: 'ItemSelectModal',
    props: {},
    mixins: [elasticList,alertMixins],
    components: {ElasticListComponent},
    computed: {},
    provide() {
        return {
            selectModalData: this.selectData,
            checkItem: this.checkItem
        }
    },
    data() {
        return {
            itemData: [],
            itemIndex: '',
            defaultFilter: {},
            //TODO : 매거진 아이템 선택 버그 수정 건 충돌 날 경우 feature 브랜치로 덮어쓰시면 됩니다.
            seq: 0,
        }
    },
    mounted() {

    },
    methods: {
        handlerBeforeOpen(event) {
            if (!util.isEmpty(event.params) && !util.isEmpty(event.params.itemData)) {
                this.itemData = event.params.itemData;
                let itemsIdx = [];
                util.Array.each(this.itemData, (data, index, arr) => {
                    itemsIdx.push(data.i_idx);

                })
                if(itemsIdx.length > 0) {
                    this.defaultFilter = {
                        query: {
                            bool: {
                                must: [
                                    {match: {"i_is_delete": 0}},
                                ],
                                must_not: [
                                    {terms: {"i_idx" : itemsIdx}}
                                ]
                            }
                        }
                    }
                }
            }else if(!util.isEmpty(event.params) && !util.isEmpty(event.params.defaultFilter)){
                this.defaultFilter = event.params.defaultFilter
            }
            //TODO : 매거진 아이템 선택 버그 수정 건 충돌 날 경우 feature 브랜치로 덮어쓰시면 됩니다.
            if(!util.isEmpty(event.params) && !util.isEmpty(event.params.seq)){
                this.seq = event.params.seq;
            }else {
                this.seq = 0;
            }
        },
        handlerOpened() {
            EventBus.$on('setSelectModalData', this.setSelectModalData);
        },
        handlerBeforeClose() {
            this.itemData = [];
            this.defaultFilter = {};
            // this.$router.replace(this.$route.path);
            EventBus.$off('setSelectModalData');
        },
        modalClose() {
            this.$modal.hide('item-select-modal');
        },
        checkItem(data) {
            let itemIndex = this.itemData.findIndex(item => item.key === data.i_idx);
            return itemIndex > -1;
        },
        setSelectModalData(items) {
            this.itemData = items;
        },
        selectData(data) {
            if(this.itemData.length < 1) {
                this.errorAlert('1개 이상 선택해주세요.')
                return false;
            }
            //TODO : 매거진 아이템 선택 버그 수정 건 충돌 날 경우 feature 브랜치로 덮어쓰시면 됩니다.
            EventBus.$emit('runSelectItem'+this.seq, this.itemData);
            this.modalClose();
        },

    }
}
</script>
